import { useState, useCallback } from 'react'
import { GraphQLCampaignRepository } from '../../../infrastructure/graphql/CampaignRepositoryImpl'
import { useAuth0 } from '@auth0/auth0-react'

export function useDeleteCampaign() {
  const { getIdTokenClaims } = useAuth0()

  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const deleteCampaign = useCallback(
    async (campaignId: string) => {
      setDeleting(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLCampaignRepository(getToken)
        await repo.delete(campaignId)
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setDeleting(false)
      }
    },
    [getIdTokenClaims]
  )

  return { deleteCampaign, deleting, error }
}
